import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = { //要设置的全局访问的state对象
  activeDisaster: '',
  areaConfig: [],
  areaReady: false,
  disasterConfig: {},
  disasterReady: false,
  menuName: '',
  //要设置的初始属性值
};
const getters = { //实时监听state值的变化(最新状态)
  getActiveDisaster(state) { //承载变化的showFooter的值
    return state.activeDisaster
  },
  isDisasterReady(state) {
    return state.disasterReady
  },
  isAreaReady(state) {
    return state.areaReady
  }
};
const mutations = {
  setActiveDisaster(state, disaster) { //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
    state.activeDisaster = disaster;
  },
  setDisaster(state, disasterConfig) {
    state.disasterReady = true;
    state.disasterConfig = disasterConfig;
  },
  setArea(state, areaConfig) {
    state.areaReady = true;
    state.areaConfig = areaConfig;
  },
  setMenuName(state, menu) {
    state.menuName = menu;
  }
};
const actions = {
  setActiveDisaster(context, disaster) { //自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
    context.commit('setActiveDisaster', disaster);
  },
  setDisaster(context, disasterConfig) {
    context.commit('setDisaster', disasterConfig);
  },
  setArea(context, areaConfig) {
    context.commit('setArea', areaConfig);
  },
  setMenuName(context, menu) {
    context.commit('setMenuName', menu);
  }
};
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js